import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-32f08908"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "agenda" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "agenda__item__date" }
const _hoisted_4 = {
  key: 0,
  class: "agenda__item__date--to"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_6 = { class: "agenda__item__header" }
const _hoisted_7 = { class: "agenda__item__title" }
const _hoisted_8 = { class: "agenda__item__text" }
const _hoisted_9 = {
  key: 0,
  class: "agenda__item__image"
}
const _hoisted_10 = ["src", "alt", "width", "height"]
const _hoisted_11 = { class: "agenda__item__readmore_container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ButtonLink = _resolveComponent("ButtonLink")!
  const _directive_sanitize = _resolveDirective("sanitize")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.agendaItems, (item) => {
      return (_openBlock(), _createElementBlock("div", {
        class: _normalizeClass(["agenda__item", [
        { 'agenda__item--partner': item.partner },
        { 'agenda__item--no-image': !item.image },
      ]]),
        key: `item-${item.link}`,
        "data-reveal-on-scroll": "true"
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createTextVNode(_toDisplayString(item.date) + " ", 1),
            (item.dateTo)
              ? (_openBlock(), _createElementBlock("span", _hoisted_4, [
                  _hoisted_5,
                  _createTextVNode("- " + _toDisplayString(item.dateTo), 1)
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", {
              class: _normalizeClass(["agenda__item__organizer", { 'agenda__item__organizer--partner': item.partner }])
            }, _toDisplayString(item.partner ? item.partner : "Nederlands Mijnmuseum"), 3),
            _createElementVNode("div", _hoisted_7, _toDisplayString(item.title), 1)
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_8, null, 512), [
            [_directive_sanitize, item.text]
          ]),
          (item.image)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _createElementVNode("img", {
                  src: item.image.src,
                  alt: item.image.alt || item.title,
                  width: item.image.width,
                  height: item.image.height
                }, null, 8, _hoisted_10)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_11, [
            _createVNode(_component_ButtonLink, {
              href: item.link.href,
              target: item.link.target,
              label: item.link.label === '' ? 'lees meer' : item.link.label,
              class: "agenda__item__readmore"
            }, null, 8, ["href", "target", "label"])
          ])
        ])
      ], 2))
    }), 128))
  ]))
}